<cap-content-header>
  <cap-title>
    {{ "person.SucheTitel" | translate }}
  </cap-title>
</cap-content-header>

<ul [(activeId)]="searchMode" #nav="ngbNav" class="nav-tabs" ngbNav>
  <li [ngbNavItem]="'searchStandard'">
    <a ngbNavLink>{{ "Suche" | translate }}</a>
    <ng-template id="standard" ngbNavContent>
      <cap-persongb-suche-standard (tabErweitertActive)="saveTabSettings($event)"></cap-persongb-suche-standard>
    </ng-template>
  </li>

  <li [ngbNavItem]="'searchErweitert'">
    <a ngbNavLink>{{ "ErweiterteSuche" | translate }}</a>
    <ng-template id="erweitert" ngbNavContent>
      <cap-persongb-suche-erweitert (tabErweitertActive)="saveTabSettings($event)"></cap-persongb-suche-erweitert>
    </ng-template>
  </li>

  <li [ngbNavItem]="'searchFachId'">
    <a ngbNavLink>{{ "EgbpidSuche" | translate }}</a>
    <ng-template id="egbpid" ngbNavContent>
      <cap-persongb-suche-egbpid (tabErweitertActive)="saveTabSettings($event)"></cap-persongb-suche-egbpid>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>
